import { ca } from '@cian/analytics';

import { EOrderField } from '../../repositories/favorites/entities/get_favorites_for_desktop/GetFavoritesForDesktopRequestSchema';

export function trackFiltersClick() {
  ca('event', {
    name: 'oldevent',
    action: 'click_filter',
    category: 'ListingFavorites',
    label: '',
  });
}

export function trackSortClick(order: EOrderField) {
  const orderMap = {
    [EOrderField.Added]: 'date_added',
    [EOrderField.Created]: 'date_pub',
    [EOrderField.Price]: 'price_asc',
  };

  ca('event', {
    name: 'oldevent',
    action: 'sorting',
    category: 'ListingFavorites',
    label: orderMap[order],
  });
}
